import React, { useMemo } from 'react';

import {
  StyledCardsContainer,
  StyledCategoryContainer,
  StyledText,
} from './styles';
import type { VendorProductsCategoryProps } from './types';
import VendorProductCard from './VendorProductCard';

export default function VendorProductsCategory({
  category,
  containerRef,
  onProductClick,
  vendorNameId,
  ...props
}: VendorProductsCategoryProps) {
  const products = useMemo(
    () => category.products.filter((product) => !product.isDeleted),
    [category.products]
  );
  return (
    <StyledCategoryContainer id={category.nameId} ref={containerRef} {...props}>
      <StyledText as="heading5">{category.name}</StyledText>
      <StyledText as="body2">{category.description}</StyledText>

      <StyledCardsContainer>
        {products.map((product) => (
          <VendorProductCard
            data={product}
            key={product.id}
            onProductClick={onProductClick}
            vendorNameId={vendorNameId}
          />
        ))}
      </StyledCardsContainer>
    </StyledCategoryContainer>
  );
}
